import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartSlideout from './components/CartSlideout';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Journal from './pages/Journal';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import Checkout from './pages/Checkout';
import Success from './pages/Success';
import Invoice_COM_2025_001 from './pages/Invoice_COM_2025_001';
import CertificateSuStainedV2 from './pages/Certificate_SuStained_V2';
import useScrollToTop from './hooks/useScrollToTop';

// Google Analytics pageview tracking
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function usePageViewAnalytics() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);
}

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <Router>
          <AppContent />
        </Router>
      </CartProvider>
    </HelmetProvider>
  );
}

function AppContent() {
  const location = useLocation();
  useScrollToTop();
  usePageViewAnalytics();
  
  // Hide header and footer for standalone document pages
  const isDocumentPage =
    location.pathname.startsWith('/invoice/') ||
    location.pathname.startsWith('/coa');
  
  return (
    <div className="App">
      {!isDocumentPage && <Header />}
      {!isDocumentPage && <CartSlideout />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/invoice/COM-2025-001" element={<Invoice_COM_2025_001 />} />
          <Route path="/coasustainedv2" element={<CertificateSuStainedV2 />} />
        </Routes>
      </main>
      {!isDocumentPage && <Footer />}
    </div>
  );
}

export default App;
